<template>
  <div v-if="can('list-role')">
    <h2>Role list</h2>
    <div class="list-table">
      <div class="col-md-12">
        <div class="block-right col-md-2">
          <div class="btn-group float-right" style="margin-bottom: 5px">
            <input
              type="text"
              class="float-right form-control"
              style="margin: 0px"
              placeholder="Search"
              v-model="query"
              v-on:keyup.enter="searchRole()"
            />
            <span
              class="fa fa-search btn btn-success"
              style="cursor: pointer"
              v-on:click="searchRole()"
            />
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Guard Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in roleList" :key="data.id">
            <td>{{ data.name }}</td>
            <td>{{ data.guard_name }}</td>
            <td>
              <router-link
                class="fa fa-edit text-warning"
                title="Edit"
                :to="{
                  name: 'EditRole',
                  params: {
                    id: data.id,
                  },
                }"
              ></router-link
              >&nbsp;
              <i
                title="Delete"
                class="fa fa-trash text-danger"
                v-on:click="deleteRole(data.id)"
              ></i
              >&nbsp;
              <router-link
                class="fa fa-user-plus text-primary"
                title="Assign Permission"
                :to="{
                  name: 'AssignPermissionToRole',
                  params: {
                    id: data.id,
                  },
                }"
              ></router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" v-model="currentPage">
            <option v-for="i in lastPage" :key="i" :value="i">
              Jump To Page {{ i }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <paginate
            class="block-right"
            containerClass="pagination"
            pageLinkClass="page-link"
            pageClass="page-item"
            prev-text="Prev"
            next-text="Next"
            prev-link-class="page-link"
            next-link-class="page-link"
            :page-count="lastPage"
            :click-handler="paginationClickHandler"
            v-model="currentPage"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "RoleList",

  data() {
    return {
      roleList: [],
      lastPage: 1,
      query: "",
      currentPage: 1,
    };
  },

  mounted() {
    this.isLoading(true);
    // if (this.can("list-role")) {
    this.getRoleList();
    // } else {
    //   this.$router.push({ name: "Dashboard" });
    // }
  },
  methods: {
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.getRoleList();
    },
    searchRole() {
      this.currentPage = 1;
      this.getRoleList();
    },
    ...mapMutations({
      isLoading: "loading",
    }),
    getRoleList() {
      this.$http
        .get(`role?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.roleList = res.data.data.data;
            this.lastPage = res.data.data.last_page;
            this.isLoading(false);
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
    deleteRole(id) {
      this.$http.delete(`role/${id}`).then((res) => {
        if (res.data.status == 1) {
          this.$notify({
            group: "notifications",
            title: "Role Deleted",
            type: "error",
            text: res.data.message,
          });
          this.getRoleList();
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
        }
      });
    },
    onPageChange(page) {
      console.log(page);
      this.page.current_page = page;
    },
  },
  watch: {
    currentPage: function () {
      this.getRoleList();
    },
  },
};
</script>
